import "./trap-focus";
import "./dimmers";
import "./lock-scroll";
import "./follow-designer";
import "./_open-login-modal";
import "./scrapeSectionData";
import updateDesigners from "../helpers/updateDesigners";
import fetchDesigners from "../helpers/fetchDesigners";

window.updateDesigners = updateDesigners;
window.fetchDesigners = fetchDesigners;
